import { Link, useMatch } from "react-router-dom";
import styled from "styled-components";

type CustomNavLinkProps = {
  to: string;
  matchLinks: string[];
  children: React.ReactNode;
  style?: any;
};

const CustomLink = styled(Link)`
  all: unset;

  width: 100%;
  height: 44px;
  cursor: pointer;
  box-sizing: border-box;

  border-radius: 10px;
  padding: 0 14px;
  gap: 14px;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  font-size: 14px;
  font-weight: 500;
  color: var(--color-black-9, #344054);

  background: var(--bg-white);

  i,
  svg {
    font-size: 18px;
    flex-shrink: 0;
    color: var(--color-black-9, #344054);
  }

  :hover {
    background: var(--primary-10);
  }

  &.active {
    background: var(--primary-10);
    color: var(--color-purple);

    i,
    svg {
      color: var(--color-purple);
    }
  }
`;

export function CustomNavLink({
  to,
  matchLinks,
  children,
  style,
}: CustomNavLinkProps) {
  const match = useMatch(matchLinks[0]);
  const match2 = useMatch(matchLinks[1]);

  return (
    <CustomLink
      {...{ to }}
      className={match || match2 ? "active" : ""}
      style={style}
    >
      {children}
    </CustomLink>
  );
}
